import type { TranslateService } from '@ngx-translate/core';
import type { Character } from 'src/app/features/characters/types/character';
import {
  buildStorySetupMessage,
  mapStoryCharactersForSetup,
} from './build-story-setup-message';
import {
  GENRE_OPTIONS,
  NARRATIVE_MODE_OPTIONS,
  StorySetupAnswers,
  TONE_OPTIONS,
} from './story-setup.types';

function toLabelPairs(
  translate: TranslateService,
  options: { value: string; labelKey: string }[],
) {
  return options.map((o) => ({
    value: o.value,
    label: translate.instant(o.labelKey),
  }));
}

export function buildStorySetupMessageWithTranslate(
  answers: StorySetupAnswers,
  characters: Character[],
  ownerNames: Map<string, string>,
  translate: TranslateService,
  options?: { includeCharacters?: boolean },
): { text: string; plainText: string } {
  const t = (key: string) => translate.instant(key);
  return buildStorySetupMessage(
    answers,
    {
      genre: toLabelPairs(translate, GENRE_OPTIONS),
      tone: toLabelPairs(translate, TONE_OPTIONS),
      narrativeMode: toLabelPairs(translate, NARRATIVE_MODE_OPTIONS),
      noLimits: t('chat.storySetup.noLimits'),
      none: t('chat.storySetup.none'),
      sectionPreferences: t('chat.storySetup.sectionPreferences'),
      sectionCharacters: t('chat.storySetup.sectionCharacters'),
      fields: {
        genre: t('chat.storySetup.fields.genre'),
        tone: t('chat.storySetup.fields.tone'),
        narrativeMode: t('chat.storySetup.fields.narrativeMode'),
        contentLimits: t('chat.storySetup.fields.contentLimits'),
        mustInclude: t('chat.storySetup.fields.mustInclude'),
      },
    },
    mapStoryCharactersForSetup(characters, ownerNames),
    {
      includeCharacters: options?.includeCharacters,
      charactersPendingLabel: t('chat.storySetup.charactersPending'),
    },
  );
}
